/* <collapsible-list>
 * Mobile-only "show more" wrapper for the collapsible-content accordion list.
 *
 * Markup contract (set up by sections/collapsible-content.liquid):
 *   <collapsible-list data-expand-label="…" data-collapse-label="…">
 *     <div class="accordion-list">
 *       <div class="accordion accordion--extra">…</div>   ← hidden when collapsed
 *     </div>
 *     <button class="collapsible-content__expand-button">…</button>
 *   </collapsible-list>
 *
 * Behaviour:
 *   - mobile (max-width: 749px): rows marked .accordion--extra start hidden,
 *     button is visible. Clicking the button toggles is-expanded on the host
 *     and swaps the button label between data-expand-label / data-collapse-label.
 *   - desktop (min-width: 750px): host is forced to is-expanded so all rows
 *     are visible; the button is hidden via CSS regardless of state.
 *
 * Display/visibility is driven entirely by CSS — this class only writes
 * the .is-expanded class and the button label.
 */
class CollapsibleList extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.collapsible-content__expand-button');
    if (!this.button) return;

    this.expandLabel = this.dataset.expandLabel || this.button.textContent.trim() || 'Show more';
    this.collapseLabel = this.dataset.collapseLabel || 'Show less';
    this.expanded = false;
    this.mq = window.matchMedia('(max-width: 749px)');

    this.applyState();
    this.button.addEventListener('click', () => this.toggle());
    this.mq.addEventListener('change', () => this.applyState());
  }

  applyState() {
    const onMobile = this.mq.matches;
    const showAll = !onMobile || this.expanded;
    this.classList.toggle('is-expanded', showAll);
    this.button.setAttribute('aria-expanded', this.expanded ? 'true' : 'false');
    this.button.textContent = this.expanded ? this.collapseLabel : this.expandLabel;
  }

  toggle() {
    this.expanded = !this.expanded;
    this.applyState();
  }
}

if (!customElements.get('collapsible-list')) {
  customElements.define('collapsible-list', CollapsibleList);
}
